
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { Loader2 } from "lucide-react";

interface FormActionsProps {
  isEditing: boolean;
  onCancel: () => void;
  onSubmit: () => void; // Update to not expect an event parameter
  isLoading?: boolean;
}

export const FormActions = ({ 
  isEditing, 
  onCancel, 
  onSubmit,
  isLoading = false
}: FormActionsProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex justify-end gap-2 pt-2">
      <Button
        type="button"
        variant="outline"
        size={isMobile ? "sm" : "default"}
        onClick={onCancel}
        disabled={isLoading}
      >
        Cancel
      </Button>
      <Button
        type="button"
        size={isMobile ? "sm" : "default"}
        onClick={() => onSubmit()} // Call onSubmit without any arguments
        disabled={isLoading}
        className="bg-forest hover:bg-forest/90"
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {isEditing ? "Updating..." : "Saving..."}
          </>
        ) : (
          isEditing ? "Update Score" : "Add Score"
        )}
      </Button>
    </div>
  );
};
